import { Container, ContentContainer, AccentTypography, Loading, PageContainer, ContainedButton } from '../../theme.js';
import { dig } from "../../util/dig";
import { makeStyles } from '@material-ui/core/styles';
import * as api from "../../util/api";
import axios from 'axios';
import Backdrop from '@material-ui/core/Backdrop';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Checkbox from '@material-ui/core/Checkbox';
import CircularProgress from '@material-ui/core/CircularProgress';
import constants from "../../util/constants";
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import Icon from '@material-ui/core/Icon';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import MuiAlert from '@material-ui/lab/Alert';
import PanoramaOutlinedIcon from '@material-ui/icons/PanoramaOutlined';
import React from 'react'
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  container: {
    margin: '0 auto',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    alignItems: 'flex-start',
    maxWidth: 800,
    textAlign: 'left'
  },
  root: {
    flexGrow: 1
  },
  box: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    textAlign: 'center'
  },
  button: {
    marginLeft: theme.spacing(1)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
  media: {
    height: 140
  },
  card: {
    marginLeft: theme.spacing(2)
  },
  missingLogo: {
    fontSize: 64,
    marginTop: 38
  },
  checkBox: {
    marginTop: theme.spacing(0),
    marginBottom: theme.spacing(0),
    paddingTop: theme.spacing(0),
    paddingBottom: theme.spacing(0),
  },
  wordCountHelperText: {
    textAlign: 'right'
  }
}));


export default function Profile() {
  const [isEditing, setIsEditing] = React.useState(false);
  const [showValidationErrors, setShowValidationErrors] = React.useState(false);
  const [metaData, setMetaData] = React.useState(null);
  const [data, setData] = React.useState(null);
  const [dataError, setDataError] = React.useState(null);
  const [dataFetching, setDataFetching] = React.useState(false);
  const [dataCommitting, setDataCommitting] = React.useState(false);
  const [deleteLogo, setDeleteLogo] = React.useState(false);
  const [changeLogo, setChangeLogo] = React.useState(false);
  const [logoVersion, setLogoVersion] = React.useState(new Date().getTime());
  const [categoryData, setCategoryData] = React.useState({});
  const [message, setMessage] = React.useState({content: '', severity: 'error'});
  const countryOptions = ["Andorra","United Arab Emirates","Afghanistan","Antigua and Barbuda","Anguilla","Albania","Armenia","Angola","Antarctica","Argentina","Austria","Australia","Aruba","Aland Islands","Azerbaijan","Bosnia and Herzegovina","Barbados","Bangladesh","Belgium","Burkina Faso","Bulgaria","Bahrain","Burundi","Benin","Saint Barthélemy","Bermuda","Brunei Darussalam","Bolivia, Plurinational State of","Bonaire, Sint Eustatius and Saba","Brazil","Bahamas","Bhutan","Bouvet Island","Botswana","Belarus","Belize","Canada","Cocos (Keeling) Islands","Congo, the Democratic Republic of the","Central African Republic","Congo","Switzerland","Cote d’Ivoire","Cook Islands","Chile","Cameroon","China","Colombia","Costa Rica","Cuba","Cape Verde","Curaçao","Christmas Island","Cyprus","Czech Republic","Germany","Djibouti","Denmark","Dominica","Dominican Republic","Algeria","Ecuador","Estonia","Egypt","Western Sahara","Eritrea","Spain","Ethiopia","Finland","Fiji","Falkland Islands (Malvinas)","Faroe Islands","France","Gabon","United Kingdom","Grenada","Georgia","French Guiana","Guernsey","Ghana","Gibraltar","Greenland","Gambia","Guinea","Guadeloupe","Equatorial Guinea","Greece","South Georgia and the South Sandwich Islands","Guatemala","Guinea-Bissau","Guyana","Heard Island and McDonald Islands","Honduras","Croatia","Haiti","Hungary","Indonesia","Ireland","Israel","Isle of Man","India","British Indian Ocean Territory","Iraq","Iran, Islamic Republic of","Iceland","Italy","Jersey","Jamaica","Jordan","Japan","Kenya","Kyrgyzstan","Cambodia","Kiribati","Comoros","Saint Kitts and Nevis","Korea, Democratic People’s Republic of","Korea, Republic of","Kuwait","Cayman Islands","Kazakhstan","Lao People’s Democratic Republic","Lebanon","Saint Lucia","Liechtenstein","Sri Lanka","Liberia","Lesotho","Lithuania","Luxembourg","Latvia","Libya","Morocco","Monaco","Moldova, Republic of","Montenegro","Saint Martin (French part)","Madagascar","Macedonia, the former Yugoslav Republic of","Mali","Myanmar","Mongolia","Macao","Martinique","Mauritania","Montserrat","Malta","Mauritius","Maldives","Malawi","Mexico","Malaysia","Mozambique","Namibia","New Caledonia","Niger","Norfolk Island","Nigeria","Nicaragua","Netherlands","Norway","Nepal","Nauru","Niue","New Zealand","Oman","Panama","Peru","French Polynesia","Papua New Guinea","Philippines","Pakistan","Poland","Saint Pierre and Miquelon","Pitcairn","Palestine","Portugal","Paraguay","Qatar","Reunion","Romania","Serbia","Russian Federation","Rwanda","Saudi Arabia","Solomon Islands","Seychelles","Sudan","Sweden","Singapore","Saint Helena, Ascension and Tristan da Cunha","Slovenia","Svalbard and Jan Mayen","Slovakia","Sierra Leone","San Marino","Senegal","Somalia","Suriname","South Sudan","Sao Tome and Principe","El Salvador","Sint Maarten (Dutch part)","Syrian Arab Republic","Swaziland","Turks and Caicos Islands","Chad","French Southern Territories","Togo","Thailand","Tajikistan","Tokelau","Timor-Leste","Turkmenistan","Tunisia","Tonga","Turkey","Trinidad and Tobago","Tuvalu","Taiwan","Tanzania, United Republic of","Ukraine","Uganda","United States","Uruguay","Uzbekistan","Holy See (Vatican City State)","Saint Vincent and the Grenadines","Venezuela, Bolivarian Republic of","Virgin Islands, British","Vietnam","Vanuatu","Wallis and Futuna","Samoa","Yemen","Mayotte","South Africa","Zambia","Zimbabwe"];
  const stateOptions = {
    "Australia": [
      "Capital Territory",
      "New South Wales",
      "Northern Territory",
      "Queensland",
      "South Australia",
      "Tasmania",
      "Victoria",
      "Western Australia"
    ],
    "Brazil": [
      "Acre",
      "Alagoas",
      "Amazonas",
      "Amapá",
      "Bahia",
      "Ceará",
      "Distrito Federal",
      "Espírito Santo",
      "Goiás",
      "Maranhão",
      "Minas Gerais",
      "Mato Grosso do Sul",
      "Mato Grosso",
      "Pará",
      "Paraíba",
      "Pernambuco",
      "Piauí",
      "Paraná",
      "Rio de Janeiro",
      "Rio Grande do Norte",
      "Rondônia",
      "Roraima",
      "Rio Grande do Sul",
      "Santa Catarina",
      "Sergipe",
      "São Paulo",
      "Tocantins"
    ],
    "Canada": [
      "Alberta",
      "British Columbia",
      "Manitoba",
      "New Brunswick",
      "Newfoundland and Labrador",
      "Nova Scotia",
      "Northwest Territories",
      "Nunavut",
      "Ontario",
      "Prince Edward Island",
      "Quebec",
      "Saskatchewan",
      "Yukon Territories"
    ],
    "China": [
      "Beijing",
      "Tianjin",
      "Hebei",
      "Shanxi",
      "Nei Mongol",
      "Liaoning",
      "Jilin",
      "Heilongjiang",
      "Shanghai",
      "Jiangsu",
      "Zhejiang",
      "Anhui",
      "Fujian",
      "Jiangxi",
      "Shandong",
      "Henan",
      "Hubei",
      "Hunan",
      "Guangdong",
      "Guangxi",
      "Hainan",
      "Chongqing",
      "Sichuan",
      "Guizhou",
      "Yunnan",
      "Xizang",
      "Shaanxi",
      "Gansu",
      "Qinghai",
      "Ningxia",
      "Xinjiang",
      "Chinese Taipei",
      "Hong Kong",
      "Macao"
    ],
    "Ireland": [
      "Clare",
      "Cavan",
      "Cork",
      "Carlow",
      "Dublin",
      "Donegal",
      "Galway",
      "Kildare",
      "Kilkenny",
      "Kerry",
      "Longford",
      "Louth",
      "Limerick",
      "Leitrim",
      "Laois",
      "Meath",
      "Monaghan",
      "Mayo",
      "Offaly",
      "Roscommon",
      "Sligo",
      "Tipperary",
      "Waterford",
      "Westmeath",
      "Wicklow",
      "Wexford"
    ],
    "India": [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Daman and Diu",
      "Delhi",
      "Dadra and Nagar Haveli",
      "Goa",
      "Gujarat",
      "Himachal Pradesh",
      "Haryana",
      "Jharkhand",
      "Jammu and Kashmir",
      "Karnataka",
      "Kerala",
      "Lakshadweep",
      "Maharashtra",
      "Meghalaya",
      "Manipur",
      "Madhya Pradesh",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Punjab",
      "Puducherry",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal"
    ],
    "Italy": [
      "Agrigento",
      "Alessandria",
      "Ancona",
      "Aosta",
      "Ascoli Piceno",
      "L'Aquila",
      "Arezzo",
      "Asti",
      "Avellino",
      "Bari",
      "Bergamo",
      "Biella",
      "Belluno",
      "Benevento",
      "Bologna",
      "Brindisi",
      "Brescia",
      "Barletta-Andria-Trani",
      "Bolzano",
      "Cagliari",
      "Campobasso",
      "Caserta",
      "Chieti",
      "Carbonia-Iglesias",
      "Caltanissetta",
      "Cuneo",
      "Como",
      "Cremona",
      "Cosenza",
      "Catania",
      "Catanzaro",
      "Enna",
      "Forlì-Cesena",
      "Ferrara",
      "Foggia",
      "Florence",
      "Fermo",
      "Frosinone",
      "Genoa",
      "Gorizia",
      "Grosseto",
      "Imperia",
      "Isernia",
      "Crotone",
      "Lecco",
      "Lecce",
      "Livorno",
      "Lodi",
      "Latina",
      "Lucca",
      "Monza and Brianza",
      "Macerata",
      "Messina",
      "Milan",
      "Mantua",
      "Modena",
      "Massa and Carrara",
      "Matera",
      "Naples",
      "Novara",
      "Nuoro",
      "Ogliastra",
      "Oristano",
      "Olbia-Tempio",
      "Palermo",
      "Piacenza",
      "Padua",
      "Pescara",
      "Perugia",
      "Pisa",
      "Pordenone",
      "Prato",
      "Parma",
      "Pistoia",
      "Pesaro and Urbino",
      "Pavia",
      "Potenza",
      "Ravenna",
      "Reggio Calabria",
      "Reggio Emilia",
      "Ragusa",
      "Rieti",
      "Rome",
      "Rimini",
      "Rovigo",
      "Salerno",
      "Siena",
      "Sondrio",
      "La Spezia",
      "Syracuse",
      "Sassari",
      "Savona",
      "Taranto",
      "Teramo",
      "Trento",
      "Turin",
      "Trapani",
      "Terni",
      "Trieste",
      "Treviso",
      "Udine",
      "Varese",
      "Verbano-Cusio-Ossola",
      "Vercelli",
      "Venice",
      "Vicenza",
      "Verona",
      "Medio Campidano",
      "Viterbo",
      "Vibo Valentia"
    ],
    "Mexico": [
      "Aguascalientes",
      "Baja California",
      "Baja California Sur",
      "Chihuahua",
      "Colima",
      "Campeche",
      "Coahuila",
      "Chiapas",
      "Federal District",
      "Durango",
      "Guerrero",
      "Guanajuato",
      "Hidalgo",
      "Jalisco",
      "Mexico State",
      "Michoacán",
      "Morelos",
      "Nayarit",
      "Nuevo León",
      "Oaxaca",
      "Puebla",
      "Querétaro",
      "Quintana Roo",
      "Sinaloa",
      "San Luis Potosí",
      "Sonora",
      "Tabasco",
      "Tlaxcala",
      "Tamaulipas",
      "Veracruz",
      "Yucatán",
      "Zacatecas"
    ],
    "New Zealand": [
      "Auckland",
      "Bay Of Plenty",
      "Canterbury",
      "Coromandel",
      "Gisborne",
      "Hawkes Bay",
      "Marlborough",
      "Manawatu",
      "Northland",
      "Nelson",
      "Otago",
      "Southland",
      "Tasman",
      "Taranaki",
      "West Coast",
      "Waikato",
      "Wellington"
    ],
    "United States": [
      "Alaska",
      "Alabama",
      "Arkansas",
      "Arizona",
      "California",
      "Colorado",
      "Connecticut",
      "District of Columbia",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Iowa",
      "Idaho",
      "Illinois",
      "Indiana",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Massachusetts",
      "Maryland",
      "Maine",
      "Michigan",
      "Minnesota",
      "Missouri",
      "Mississippi",
      "Montana",
      "North Carolina",
      "North Dakota",
      "Nebraska",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "Nevada",
      "New York",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Virginia",
      "Vermont",
      "Washington",
      "Wisconsin",
      "West Virginia",
      "Wyoming"
    ]
  };

  const categoryError = Object.values(categoryData).filter((v) => v).length < 1;
  const clientContactNumberError = ((data || {}).clientContactNumber || '').length < 1;
  const clientContactEmailError = ((data || {}).clientContactEmail || '').length < 1;
  const nameError = ((data || {}).name || '').length < 1;
  const billingCityError = ((data || {}).billingCity || '').length < 1;
  const billingStateError = (((data || {}).billingState || '').length < 1) && ((data || {}).billingCountry in stateOptions);
  const billingCountryError = ((data || {}).billingCountry || '').length < 1;
  const billingPostalCodeError = ((data || {}).billingPostalCode || '').length < 1;
  const serviceRangeError = ((data || {}).serviceRange || '').length < 1;

  const SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH = 500;
  const CERTIFICATION_MAX_LENGTH = 50;

  const handleChange = e => {
    const { name, value } = e.target;
    setData(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleChangeCountry = e => {
    const { name, value } = e.target;
    setData(prevState => ({
        ...prevState,
        [name]: value,
        billingState: ''
    }));
  };

  const handleCategoryChange = e => {
    const { name, checked } = e.target;
    setCategoryData(prevState => ({
      ...prevState,
      [name]: checked
    }));
    setData(prevState => ({
      ...prevState,
      category: Object.keys(categoryData).filter(key => ({...categoryData, [name]: checked})[key] === true).join(';')
    }));
  };;

  const handleCertificationChange = e => {
    const { name, value } = e.target;
    const prevCertifications = (data.certifications || '').split('\n');
    let nextCertifications = [
      prevCertifications[0] || '',
      prevCertifications[1] || '',
      prevCertifications[2] || ''
    ];
    nextCertifications[parseInt(name.split('-')[1])] = value;
    setData(prevState => ({
      ...prevState,
      certifications: nextCertifications.join('\n')
    }));
  };;

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setMessage(prevState => ({content: '', severity: prevState.severity}));
  };

  const handleDeleteLogo = e => {
    setChangeLogo(false);
    setDeleteLogo(true);
  };

  const handleChangeLogo = e => {
    if (e.target.files) {
      setDeleteLogo(false);
      setChangeLogo(e.target.files[0]);
    } else {
      setChangeLogo(null);
    }
  };

  React.useEffect(() => {
    if (!dataFetching && !dataError && !data) {
      setDataFetching(true);
      api.getPartner().then(function(response) {
        setLogoVersion(new Date().getTime());
        if (response.data === null) {
          localStorage.removeItem(constants.storage.ACCESS_TOKEN);
          window.location.href = "/signin";
        } else {
          setData(response.data);
          api.getPartnerMetaData().then(function(metaDataResponse) {
            setMetaData(metaDataResponse.data);
            setCategoryData(metaDataResponse.data.category.reduce((object, category) => {
              object[category] = (response.data.category || '').indexOf(category) !== -1;
              return object;
            }, {}));
          });
        }
      }).catch(function (error) {
        if (error.name !== 'AbortError') {
          setDataError(error);
        }
      }).then(function () {
        setDataFetching(false);
        setDataCommitting(false);
      });
    }
  }, [data, dataError, dataFetching, metaData]);

  function beginEdit() {
    setDeleteLogo(false);
    setChangeLogo(false);
    setIsEditing(true);
  }

  async function commitEdit() {
    setShowValidationErrors(true);

    if (![
      categoryError,
      clientContactNumberError,
      clientContactEmailError,
      nameError,
      billingCityError,
      billingCountryError,
      billingPostalCodeError,
      billingStateError,
      serviceRangeError].every(e => !e)) {
      setMessage({content: 'Please fill in all the required fields.', severity: 'error'});
      return;
    }

    setDataCommitting(true);

    // Commit logo.
    if (changeLogo) {
      await api.updatePartnerLogo(changeLogo.type).then(async function (response) {
        await axios.put(response.data.uploadUrl, changeLogo, { headers: { 'Content-Type': changeLogo.type }}).then(function (s3Response) {
          data.logo = response.data.logoUrl;
        }).catch(function (error) {
          setMessage({content: 'There was a problem updating your logo', severity: 'error'});
        });
      }).catch(function (error) {
        setMessage({content: 'There was a problem updating your logo', severity: 'error'});
      });
    } else if (deleteLogo) {
      data.logo = '';
    }

    // Geocode address.
    // TODO: Geocoding is performed within SF.
    // await geocode([data.billingCity, data.billingState, data.billingCountry, data.billingPostalCode]).then(function (response) {
    //   data.billingLatitude = response.latitude;
    //   data.billingLongitude = response.longitude;
    // });

    // Commit partner data.
    api.updatePartner(data).then(function(response) {
      setShowValidationErrors(false);
      setData(response.data);
      setCategoryData(metaData.category.reduce((object, category) => {
        object[category] = (response.data.category || '').indexOf(category) !== -1;
        return object;
      }, {}));
      setMessage({
        content: 'Updated profile',
        severity: 'success'
      })
      setIsEditing(false);
    }).catch(function (error){
      if (error.name !== 'AbortError') {
        setMessage({content: JSON.stringify(dig(error, ['response', 'data'])) || error.message || 'There was a problem updating your profile', severity: 'error'});
      }
    }).then(function() {
      setDataCommitting(false);
      setLogoVersion(new Date().getTime());
    });
  }

  function cancelEdit() {
    setShowValidationErrors(false);
    if (!dataCommitting) {
      setDataCommitting(true);
      api.getPartner().then(function(response) {
        setData(response.data);
        setCategoryData(metaData.category.reduce((object, category) => {
          object[category] = (response.data.category || '').indexOf(category) !== -1;
          return object;
        }, {}));
      }).then(function() {
        setIsEditing(false);
        setDataCommitting(false);
        setLogoVersion(new Date().getTime());
      })
    }
  }

  const classes = useStyles();

  if (!data || !categoryData || !metaData) {
    return (
      <Container>
        <Loading />
      </Container>
    );
  } else {
    return (
      <Container>
        <ContentContainer>
          <PageContainer>
            <Snackbar open={message.content.length > 0} autoHideDuration={4000} onClose={handleClose} anchorOrigin={{vertical: 'top', horizontal: 'center'}}>
              <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={message.severity}>
                <Typography>{message.content}</Typography>
              </MuiAlert>
            </Snackbar>
            <Backdrop className={classes.backdrop} open={dataCommitting}>
              <CircularProgress color="inherit" />
            </Backdrop>
            <Grid container className={classes.root}>
              <Grid container style={{marginTop: 16, marginBottom: 24}}>
                <Grid item xs={6}>
                  <AccentTypography variant="h1">Partner Profile</AccentTypography>
                </Grid>
                <Grid align="right" item xs={6} style={{paddingTop: 10}}>
                  {isEditing ? (
                    <div>
                      <ContainedButton color="primary" variant="contained" startIcon={<Icon>cancel</Icon>} onClick={cancelEdit} className={classes.button}>Cancel</ContainedButton>
                      <ContainedButton color="primary" startIcon={<Icon>save</Icon>} variant="contained" className={classes.button} onClick={commitEdit}>Save</ContainedButton>
                    </div>
                  ) : <ContainedButton color="primary" startIcon={<Icon>create</Icon>} variant="contained" className={classes.button} onClick={beginEdit}>Edit</ContainedButton>}
                </Grid>
              </Grid>
              <Grid item xs={7}>
                <Typography style={{marginBottom: 10}}>Please setup/edit your Partner Profile. This information will be promoted within the Partner Directory accessible publicly via our website and apps. Please enter the information EXACTLY as you wish it to be shown in the directory.</Typography>
              </Grid>
              <Grid item xs={5}>

              </Grid>
              <Grid item xs={8}>
                <Box className={classes.box}>
                  <TextField required error={showValidationErrors && nameError} id="name" name="name" label="Company Name" value={data.name} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              <Grid item xs={4}>
                <Box className={classes.box}>
                  {isEditing ? (
                    <Card className={classes.card} variant="outlined">
                      <CardActionArea>
                        {data.logo === null ? (
                          <CardMedia className={classes.media} title="Logo">
                            <PanoramaOutlinedIcon className={classes.missingLogo} />
                          </CardMedia>) : (
                            <CardMedia className={classes.media} image={`${data.logo}?t=${logoVersion}`} title="Logo"></CardMedia>
                        )}
                        <CardContent style={{padding: 0, marginTop: 10}}>
                          {deleteLogo ? (<Typography color="textSecondary">Logo will be removed on save.</Typography>) : ''}
                          {changeLogo ? (<Typography color="textSecondary">Logo will be changed on save.</Typography>) : ''}
                        </CardContent>
                      </CardActionArea>
                      <CardActions style={{textAlign: 'center'}}>
                        {data.logo ? (<Button size="small" startIcon={<Icon>delete</Icon>} color="primary" onClick={handleDeleteLogo}>Remove</Button>) : ''}
                        <input id="logo" name="logo" accept="image/*" type="file" style={{ display: 'none' }} onChange={handleChangeLogo} />
                        <label htmlFor='logo'>
                          <Button component="span" size="small" color="primary" startIcon={<Icon>cloud</Icon>}>{data.logo ? 'Change' : 'Upload Logo'}</Button>
                        </label>
                      </CardActions>
                    </Card>) : (
                    <Card className={classes.card} variant="outlined">
                      {data.logo === null ? (
                        <CardMedia className={classes.media} title="Logo">
                          <PanoramaOutlinedIcon className={classes.missingLogo} />
                        </CardMedia>) : (
                          <CardMedia className={classes.media} image={`${data.logo}?t=${logoVersion}`} title="Logo"></CardMedia>
                      )}
                    </Card>
                    )}
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.box} style={{paddingRight: 4}}>
                  <TextField required error={showValidationErrors && clientContactNumberError} id="clientContactNumber" name="clientContactNumber" label="Business Phone Number" value={data.clientContactNumber || ''} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.box} style={{paddingLeft: 4}}>
                  <TextField required error={showValidationErrors && clientContactEmailError} id="clientContactEmail" name="clientContactEmail" label="Business Email" value={data.clientContactEmail || ''} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.box}>
                  <TextField id="website" name="website" label="Website" value={data.website || ''} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.box} style={{textAlign: 'left'}}>
                  {/* <GooglePlaces required id="billingCity" name="billingCity" label="Suburb" value={data.billingCity} country={data.billingCountry} onChange={handleAddressChange} fullWidth={true} disabled={!isEditing} placeTypes={['(regions)']} /> */}
                  <TextField required error={showValidationErrors && billingCityError} id="billingCity" name="billingCity" label="Suburb" value={data.billingCity} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              {/* <Grid item xs={6}>
                <Box className={classes.box} style={{textAlign: 'left', paddingLeft: 4}}>
                  <TextField required error={showValidationErrors && billingStateError} id="billingState" name="billingState" label="State" value={data.billingState} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid> */}
              <Grid item xs={6}>
                {data.billingCountry in stateOptions ? (
                <Box className={classes.box} style={{textAlign: 'left', paddingLeft: 4}}>
                  <FormControl required error={showValidationErrors && billingStateError}>
                    <InputLabel>State</InputLabel>
                    <Select style={{minWidth: 300}} id="billingState" name="billingState" options={stateOptions[data.billingCountry]} value={data.billingState || ''} onChange={handleChange} disabled={!isEditing}>
                      {stateOptions[data.billingCountry].map((row) => (
                        <MenuItem key={row} value={row}>{row}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
                ) : (null)}
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.box} style={{textAlign: 'left'}}>
                  <FormControl required error={showValidationErrors && billingCountryError}>
                    <InputLabel>Country</InputLabel>
                    <Select style={{minWidth: 300}} id="billingCountry" name="billingCountry" options={countryOptions} value={data.billingCountry} onChange={handleChangeCountry} disabled={!isEditing}>
                      {countryOptions.map((row) => (
                        <MenuItem key={row} value={row}>{row}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={6}>
                <Box className={classes.box} style={{paddingLeft: 4}}>
                  {/* <GooglePlaces required id="billingPostalCode" name="billingPostalCode" label="Postal Code" value={data.billingPostalCode} country={data.billingCountry} onChange={handleAddressChange} fullWidth={true} disabled={!isEditing}  placeTypes={['(regions)']} /> */}
                  <TextField required error={showValidationErrors && billingPostalCodeError} id="billingPostalCode" name="billingPostalCode" label="Postal Code" value={data.billingPostalCode} onInput={handleChange} fullWidth={true} disabled={!isEditing} />
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.box} style={{textAlign: 'left'}}>
                  <FormControl required error={showValidationErrors && serviceRangeError}>
                    <InputLabel>Service Range</InputLabel>
                    <Select style={{minWidth: 300}} id="serviceRange" name="serviceRange" value={data.serviceRange || ''} onChange={handleChange} disabled={!isEditing}>
                      {metaData.serviceRange.map((row) => (
                        <MenuItem key={row} value={row}>{row}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormHelperText>
                    {isEditing ? "Please choose the range of the area in which you provide your services. This should be calculated from the distance from your Postcode provided above." : ""}
                  </FormHelperText>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.box} style={{textAlign: 'left'}}>
                  <FormControl required error={showValidationErrors && categoryError} component="fieldset">
                    <FormLabel component="legend" style={{marginBottom: 8}}>Categories</FormLabel>
                    <FormHelperText>
                      {isEditing ? "Please select the categories that you class your business." : ""}
                    </FormHelperText>
                    <FormGroup>
                      {metaData.category.map((row) => (
                        <FormControlLabel
                        control={
                          <Checkbox checked={categoryData[row] || false} onChange={handleCategoryChange} name={row} className={classes.checkBox} />
                        }
                        disabled={!isEditing}
                        label={row}
                        key={row}
                        />
                      ))}
                    </FormGroup>
                    {categoryError && isEditing ? (<FormHelperText>At least one category selection is required</FormHelperText>) : null}
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.box} style={{textAlign: 'left'}}>
                  <FormControl fullWidth>
                    <FormLabel component="legend" style={{marginBottom: 8}}>Certifications</FormLabel>
                    <FormHelperText>
                      {isEditing ? "Please enter up to 3 Certifications you would like to list on your public profile." : ""}
                    </FormHelperText>
                    <TextField id="certifications-1" name="certifications-0" label="" value={(data.certifications || '').split("\n")[0]} onInput={handleCertificationChange} fullWidth={true} disabled={!isEditing} inputProps={{ maxLength: SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH }} helperText={isEditing ? `${((data.certifications || '').split("\n")[0] || '').length}/${CERTIFICATION_MAX_LENGTH}` : ""} FormHelperTextProps={{className: classes.wordCountHelperText}} />
                    <TextField id="certifications-2" name="certifications-1" label="" value={(data.certifications || '').split("\n")[1]} onInput={handleCertificationChange} fullWidth={true} disabled={!isEditing} inputProps={{ maxLength: SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH }} helperText={isEditing ? `${((data.certifications || '').split("\n")[1] || '').length}/${CERTIFICATION_MAX_LENGTH}` : ""} FormHelperTextProps={{className: classes.wordCountHelperText}} />
                    <TextField id="certifications-3" name="certifications-2" label="" value={(data.certifications || '').split("\n")[2]} onInput={handleCertificationChange} fullWidth={true} disabled={!isEditing} inputProps={{ maxLength: SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH }} helperText={isEditing ? `${((data.certifications || '').split("\n")[2] || '').length}/${CERTIFICATION_MAX_LENGTH}` : ""} FormHelperTextProps={{className: classes.wordCountHelperText}} />
                  </FormControl>
                </Box>
              </Grid>
              <Grid item xs={12}>
                <Box className={classes.box}>
                  <TextField multiline rows={1} rowsMax={8} id="summaryOfServicesOffered" name="summaryOfServicesOffered" label="About us" value={data.summaryOfServicesOffered || ''} onInput={handleChange} fullWidth={true} disabled={!isEditing} inputProps={{ maxLength: SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH }} helperText={`${(data.summaryOfServicesOffered || '').length}/${SUMMARY_OF_SERVICES_OFFERED_MAX_LENGTH}`} FormHelperTextProps={{className: classes.wordCountHelperText}} />
                  <FormHelperText>
                    {isEditing ? "Please enter in 500 words or less, a detailed summary of you, your business and services you offer." : ""}
                  </FormHelperText>
                </Box>
              </Grid>
            </Grid>
          </PageContainer>
        </ContentContainer>
      </Container>
    );
  }
}
